import { combineReducers } from '@reduxjs/toolkit';
import chatSlice from "./chatSlice"

const chatReducer = combineReducers({
 chat :chatSlice
});

export default chatReducer;
